/**
 * @file packages/types/src/enums.ts
 * @description String union types mirroring PostgreSQL ENUM definitions.
 * These must stay in sync with the database migration files.
 */
// ---------------------------------------------------------------------------
// Projects / Clients
// ---------------------------------------------------------------------------
// Runtime array backing ErpSystem — the single source of truth for any UI
// that needs to enumerate the values (e.g. a <select>), not just type-check
// against them. Order matches public.erp_system in
// packages/db/migrations/003_create_clients.sql; keep both in sync.
export const ERP_SYSTEMS = [
    'sap_s4hana',
    'sap_ecc',
    'oracle_fusion',
    'oracle_ebs',
    'microsoft_dynamics365',
    'netsuite',
    'workday',
    'other',
];
//# sourceMappingURL=enums.js.map